import { useParams } from "react-router-dom"

export const useClubId = (): string => {
  const { clubId } = useParams<{ clubId: string }>()

  return clubId ?? ""
}
